import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';

// Service worker disabled temporarily - causing cache issues
// Will re-enable after testing

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
